import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultComponent } from './../layout/default/default.component';
import { MainListComponent } from './main-list/main-list.component';
import { GujaratListComponent } from './gujarat-list/gujarat-list.component';
import { BollywoodListComponent } from './bollywood-list/bollywood-list.component';
import { SportsListComponent } from './sports-list/sports-list.component';
import { InternationalListComponent } from './international-list/international-list.component';
const routes: Routes = [
  {
    path: '',
    component: DefaultComponent,
    children: [
      {
        path: 'main-list-import',
        component: MainListComponent
      },
      {
        path: 'gujarat-list-import',
        component: GujaratListComponent
      },
      {
        path: 'bollywood-list-import',
        component: BollywoodListComponent
      },
      {
        path: 'sports-list-import',
        component: SportsListComponent
      },
      {
        path: 'international-list-import',
        component: InternationalListComponent
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ImportedNewsRoutingModule { }
